module.exports = __webpack_public_path__ + "img/2.03d6c59a.png";